//import axiosLoadingIndicatorFactory from '../axios-loading-indicator';
import axios from 'axios';
import handlers from './default-handlers';

export default {
    run(vue, formData, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.uploads.run, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    avatar(vue, formData, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.uploads.avatar, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },
}
